import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LecturaProvider } from './context/LecturaContext';
import Landing from './components/Landing';
import Formulario from './components/Formulario';
import Procesando from './components/Procesando';
import Resultado from './components/Resultado';

function App() {
  return (
    <LecturaProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/lectura" element={<Formulario />} />
          <Route path="/procesando" element={<Procesando />} />
          <Route path="/resultado" element={<Resultado />} />
        </Routes>
      </Router>
    </LecturaProvider>
  );
}

export default App;